export const description_attributes = [
    'color',
    { attribute: 'kw_dimensions', unit: 'cm' },
    { attribute: 'weight', unit: 'kg', transform: 'number' },
    { attribute: 'kw_volume', unit: 'l', transform: 'number' },
    'kw_material_new',
];
export const equipment_attribute = [
    'kw_outdoor_backpacks',
    'kw_outdoor_bags',
    'kw_outdoor_diverse',
    'kw_outdoor_luggages',
    'kw_interior_backpacks',
    'kw_interior_diverses',
    'kw_interior_luggages',
];

export const info_attributes = [
    'kw_serie',
    'sku',
    'kw_mpn',
    'kw_product_type',
    'kw_sizeindex',
    'kw_rolls_num',
    {
        attribute: 'kw_main_color',
        fallback: 'color',
    },
    {
        attribute: 'kw_dimensions',
        fallback: ['kw_height', 'kw_width', 'kw_depth'],
        unit: 'cm',
    },
    { attribute: 'kw_depth_extended', unit: 'cm' },
    { attribute: 'kw_volume', unit: 'l', transform: 'number' },
    { attribute: 'kw_volume_extended', unit: 'l', transform: 'number' },
    { attribute: 'weight', unit: 'kg', transform: 'number' },
    {
        attribute: ['kw_outdoor_backpacks', 'kw_outdoor_bags', 'kw_outdoor_diverse', 'kw_outdoor_luggages'],
        name: 'product.exterior',
    },
    {
        attribute: ['kw_interior_backpacks', 'kw_interior_diverses', 'kw_interior_luggages'],
        name: 'product.interior',
    },
    'kw_material_new',
    'kw_eancode',
];
